import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=9485b2a4"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProfileDropdown.vue?vue&type=style&index=0&id=9485b2a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports